import { HTMLDisplay, ResourceTimelineItem, Stack } from '@all-manager/design-system-v2';
import type { ReactNode } from 'react';
import type { ActivityTimelineFeed } from '../../../../types';
import ActivityTimelineCommunicationPreview from './ActivityTimelineCommunicationPreview/ActivityTimelineCommunicationPreview';
import ActivityTimelineDocumentsList from './ActivityTimelineDocumentsList';
import ActivityTimelineMenuActions from './ActivityTimelineMenuActions/ActivityTimelineMenuActions';
import { useActivityTimelineItem } from './useActivityTimelineItem';

type Props = {
  item: ActivityTimelineFeed;
  isFirst?: boolean;
  isLast?: boolean;
  showDocuments?: boolean;
  showDetails?: boolean;
  action?: ReactNode;
  renderHtmlComment?: (comment: string) => ReactNode;
  renderDocuments?: (item: ActivityTimelineFeed) => ReactNode;
};

export default function ActivityTimelineItem(props: Props) {
  const hook = useActivityTimelineItem(props);

  return (
    <ResourceTimelineItem
      color={hook.color}
      variant={props.showDetails ? 'long' : 'short'}
      title={hook.displayTitle}
      subtitle={hook.subtitle}
      action={props.action ?? (hook.isAdmin ? <ActivityTimelineMenuActions item={props.item} /> : null)}
      data-testid={`activity-timeline-item-${props.item.id}`}
    >
      {props.showDetails !== false && hook.hasDetails ? (
        <Stack spacing={0.5}>
          {props.item.comment ? (
            props.renderHtmlComment ? (
              props.renderHtmlComment(props.item.comment)
            ) : hook.isCommunication ? (
              <ActivityTimelineCommunicationPreview item={props.item} />
            ) : (
              <HTMLDisplay content={props.item.comment} />
            )
          ) : null}

          {props.showDocuments !== false ? (
            props.renderDocuments ? (
              props.renderDocuments(props.item)
            ) : (
              <ActivityTimelineDocumentsList item={props.item} />
            )
          ) : null}
        </Stack>
      ) : null}
    </ResourceTimelineItem>
  );
}
